module.exports = __webpack_public_path__ + "img/wallet.53e4ef34.svg";